export * from './components/expense/expense.component';
export * from './expense.module';



// WEBPACK FOOTER //
// ./src/app/expense/index.ts